//@ts-ignore
import  { useState } from 'react'
import { MAX_PER_PAGE } from '../../constants/other'
import SettingTable from '../../components/tables/settings/SettingsTable'

const Settings = () => {
  let [filter, setFilter] = useState({
    sort: 'name',
    perPage: MAX_PER_PAGE,
    search: '',
    direction: 'desc',
    filter: { _id: 1 },
  })

  return (
    <div>
      <h1>Settings</h1>
      <SettingTable />
    </div>
  )

  // return <h1>Setting
  //   <MyTable></MyTable>
  // </h1>
}

export default Settings
